export default __webpack_public_path__ + "static/media/ico-2.aa032fab.svg";